import intl from "react-intl-universal";

export const ExtractViewTabs = ({ activeTab, onTabChange, tagline, inline = false }) => {
  const tabs = [
    { id: "movimentacoes", label: intl.get("extract.movements") },
    { id: "consolidado-diario", label: intl.get("extract.dailyConsolidated") },
    { id: "consolidado-mensal", label: intl.get("extract.monthlyConsolidated") },
    { id: "lancamentos-futuros", label: intl.get("extract.futureEntries") },
  ];

  const tabsControl = (
    <div
      className={`extract-view-tabs ${inline ? "extract-view-tabs--inline" : ""}`}
      role="tablist"
      aria-label={intl.get("extract.viewTabsLabel")}
    >
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`extract-view-tab ${isActive ? "extract-view-tab--active" : ""}`}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
    </div>
  );

  if (inline) {
    return tabsControl;
  }

  return (
    <div className="mb-4 min-w-0 w-full max-w-full overflow-x-hidden">
      {tagline ? (
        <p className="mb-2 text-xs text-gray-500 dark:text-gray-400 md:text-sm">{tagline}</p>
      ) : null}
      {tabsControl}
    </div>
  );
};
